import { requestWithToken as request } from './api'

export const getForecast = () => {
  return request.get('/cash_flow/forecast/?format=json')
}


/**
 *
 *{

 * @param {{
      cashflow_date: date
      inflows_amount: number,
      outflows_amount: number,
      cash_balance: number,
    }
  }
 * }data
 * @returns {Promise<AxiosResponse<any>>}
 */
